/* M-03 - real-user Core Web Vitals with attribution.
   Reports INP (with target selector, interaction type, input/processing/presentation split and
   the LoAF script that blocked the frame), LCP and CLS to GA4 via the existing gtag, and to
   Clarity as custom tags. No dependencies, no build step, no visible effect.
   Everything is feature-detected and wrapped: absent gtag/clarity/PerformanceObserver is a no-op.
   Gated by the "Performance > Send Core Web Vitals" theme setting (perf_rum_enabled). */
(function () {
  'use strict';
  if (window.__soollaVitals) return;
  window.__soollaVitals = 1;
  var PO = window.PerformanceObserver;
  if (!PO || !PO.supportedEntryTypes) return;
  var supports = function (t) { return PO.supportedEntryTypes.indexOf(t) >= 0; };

  var cfg = window.__soollaRum || {};
  var pageType = cfg.pageType || (String(document.body && document.body.className).match(/template-([\w-]+)/) || [])[1] || 'unknown';
  var browser = (function () {
    var d = navigator.userAgentData;
    if (d && d.brands && d.brands.length) {
      var b = d.brands.filter(function (x) { return !/Not.?A.?Brand/i.test(x.brand); });
      if (b.length) return b[b.length - 1].brand + ' ' + b[b.length - 1].version;
    }
    var ua = navigator.userAgent;
    var m = ua.match(/(Edg|OPR|Chrome|Firefox|Version)\/(\d+)/);
    if (!m) return 'other';
    return (m[1] === 'Version' ? 'Safari' : m[1]) + ' ' + m[2];
  })();

  function sel(node) {
    if (!node || node.nodeType !== 1) return '';
    var out = [];
    for (var el = node, hops = 0; el && el.nodeType === 1 && hops < 4; el = el.parentElement, hops++) {
      var s = el.tagName.toLowerCase();
      if (el.id) { out.unshift(s + '#' + el.id); break; }
      if (typeof el.className === 'string' && el.className.trim()) {
        s += '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.');
      }
      out.unshift(s);
    }
    return out.join('>').slice(0, 180);
  }

  function observe(type, cb, opts) {
    try {
      if (!supports(type)) return;
      var o = new PO(function (l) { cb(l.getEntries(), o); });
      var init = { type: type, buffered: true };
      if (opts) for (var k in opts) init[k] = opts[k];
      o.observe(init);
      return o;
    } catch (e) {}
  }

  /* ---------- LCP ---------- */
  var lcp = null;
  observe('largest-contentful-paint', function (es) {
    var e = es[es.length - 1];
    if (e) lcp = { value: Math.round(e.startTime), target: sel(e.element) || (e.url || '').slice(0, 180) };
  });

  /* ---------- CLS (session windows, per the CWV definition) ---------- */
  var cls = { value: 0, target: '' };
  var winVal = 0, winFirst = 0, winLast = 0, winTarget = '';
  observe('layout-shift', function (es) {
    es.forEach(function (e) {
      if (e.hadRecentInput) return;
      if (winVal && e.startTime - winLast < 1000 && e.startTime - winFirst < 5000) {
        winVal += e.value; winLast = e.startTime;
      } else {
        winVal = e.value; winFirst = winLast = e.startTime; winTarget = '';
      }
      if (!winTarget && e.sources && e.sources.length) winTarget = sel(e.sources[0].node);
      if (winVal > cls.value) { cls.value = winVal; cls.target = winTarget; }
    });
  });

  /* ---------- LoAF (for INP script attribution) ---------- */
  var loafs = [];
  observe('long-animation-frame', function (es) {
    es.forEach(function (e) { loafs.push(e); });
    if (loafs.length > 60) loafs = loafs.slice(-60);
  }, { durationThreshold: 80 });

  function loafFor(start, end) {
    for (var i = loafs.length - 1; i >= 0; i--) {
      var f = loafs[i];
      if (f.startTime <= end && f.startTime + f.duration >= start) {
        var best = null;
        (f.scripts || []).forEach(function (s) { if (!best || s.duration > best.duration) best = s; });
        if (best) {
          return ((best.invokerType || '') + ' ' + (best.invoker || '') + ' ' + (best.sourceURL || '')).trim().slice(0, 200);
        }
        return 'loaf ' + Math.round(f.duration) + 'ms';
      }
    }
    return '';
  }

  /* ---------- INP ---------- */
  var interactions = {};   // interactionId -> worst entry data
  var count = 0;
  function addEvent(e) {
    if (!e.interactionId) return;
    var id = e.interactionId;
    var cur = interactions[id];
    if (!cur) { count++; }
    if (!cur || e.duration > cur.duration) {
      interactions[id] = {
        duration: e.duration,
        start: e.startTime,
        end: e.startTime + e.duration,
        name: e.name,
        target: sel(e.target),
        input: Math.max(0, e.processingStart - e.startTime),
        proc: Math.max(0, e.processingEnd - e.processingStart),
        pres: Math.max(0, e.startTime + e.duration - e.processingEnd)
      };
    }
  }
  observe('event', function (es) { es.forEach(addEvent); }, { durationThreshold: 40 });
  observe('first-input', function (es) { es.forEach(addEvent); });

  function inp() {
    var list = [];
    for (var k in interactions) list.push(interactions[k]);
    if (!list.length) return null;
    list.sort(function (a, b) { return b.duration - a.duration; });
    /* CWV definition: worst interaction, or the 98th percentile once there are 50+ of them. */
    return list[Math.min(list.length - 1, Math.floor(count / 50))];
  }

  /* ---------- reporting ---------- */
  function send(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
  }
  function clarity(k, v) {
    try { if (typeof window.clarity === 'function' && v !== '' && v != null) window.clarity('set', k, String(v).slice(0, 250)); } catch (e) {}
  }
  function bucket(v, good, poor) { return v <= good ? 'good' : (v <= poor ? 'needs-improvement' : 'poor'); }

  /* Batch 5.3: carry the active A/B assignments (set synchronously in <head> by
     snippets/soolla-experiments.liquid) on every vitals event as exp_<name>, so GA4 can read
     INP / LCP / CLS per variant instead of only in aggregate. Empty when no experiment is live. */
  var expParams = (function () {
    var out = {};
    try {
      var e = window.__soollaExp;
      if (e) for (var k in e) if (Object.prototype.hasOwnProperty.call(e, k)) out['exp_' + k] = e[k];
    } catch (x) {}
    return out;
  })();
  function withExp(p) {
    for (var k in expParams) if (Object.prototype.hasOwnProperty.call(expParams, k)) p[k] = expParams[k];
    return p;
  }

  var reported = false;
  function report() {
    if (reported) return;
    reported = true;
    var base = { page_type: pageType, browser: browser };
    var i = inp();
    if (i) {
      var v = Math.round(i.duration);
      send('web_vitals_inp', withExp({
        value: v, metric_rating: bucket(v, 200, 500), target: i.target, interaction_type: i.name,
        phase_input: Math.round(i.input), phase_processing: Math.round(i.proc),
        phase_presentation: Math.round(i.pres), loaf_script: loafFor(i.start, i.end),
        page_type: base.page_type, browser: base.browser
      }));
      clarity('inp_bucket', bucket(v, 200, 500));
      clarity('inp_target', i.target);
      clarity('inp_value', v);
    }
    if (lcp) {
      send('web_vitals_lcp', withExp({
        value: lcp.value, metric_rating: bucket(lcp.value, 2500, 4000), target: lcp.target,
        page_type: base.page_type, browser: base.browser
      }));
      clarity('lcp_bucket', bucket(lcp.value, 2500, 4000));
      clarity('lcp_target', lcp.target);
    }
    if (cls.value > 0) {
      var c = Math.round(cls.value * 1000) / 1000;
      send('web_vitals_cls', withExp({
        value: c, metric_rating: bucket(c, 0.1, 0.25), target: cls.target,
        page_type: base.page_type, browser: base.browser
      }));
      clarity('cls_bucket', bucket(c, 0.1, 0.25));
      clarity('cls_target', cls.target);
    }
  }

  addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') report(); }, true);
  addEventListener('pagehide', report, true);
})();
